import markerArival from "@assets/images/icons/marker-arrival.svg";
import markerDeparture from "@assets/images/icons/marker-departure.svg";
import marker from "@assets/images/icons/marker.png";
import { IExtLocation, IFlightSegment, ILocation, IPolyline, ITripTrackingTrack, ITripTrackingTrip, LeafletLayerName } from "@common/models";
import Map from "@components/general/Map";
import { MapType } from "@config/appConfig";
import { sprite } from "@data/tripTrack/sprite";
import { setIconForMarkers } from "@pages/RouteDemonstration";
import Translate from "@service/Translate";
import { getAirport } from "@utilize/Format";
import { FC } from "react";

interface ITripTrackMapTrackingProps {
    trip?: ITripTrackingTrip;
    flightPosition?: ITripTrackingTrack;
    flightSegment?: IFlightSegment;
}

const TripTrackMapTracking: FC<ITripTrackMapTrackingProps> = ({ trip, flightSegment, flightPosition }) => {
    const bearing = flightPosition?.bearing ?? 0;
    const { tr } = Translate;
    const path: ILocation[] = [];
    // const { dir } = Culture.getLocale();
    // const IrLocale = Culture.getLocale(Locale.fa);
    let frames;
    const icons: any = sprite.icons;
    for (const key in icons) {
        const aliases: string[] = icons[key].aliases;
        for (const alias of aliases) {
            if (alias === flightSegment?.equipmentModelInfo)
                frames = icons[key].frames[0];
        }
    }

    let index = 0;
    for (let i = 0; i < 360; i += 15) {
        if (bearing >= i) {
            if (bearing < i + 7.5) {
                index = i;
                break;
            }
            else if (bearing > i + 7.5 && bearing < i + 15) {
                index = i + 15 === 360 ? 0 : i + 15;
                break;
            }
        }
    }
    trip?.trail?.map(trail => path.push({ lat: trail.latitude ?? 0, lng: trail.longitude ?? 0 }));
    // const flightIcon = <div className="map-marker-icon" style={{ width: track.w, height: track.h, backgroundPosition: `-${track.x}px -${track.y}px`, transform: `translate(${dir === IrLocale.dir ? track.w / 2 : (track.w / 2) * -1}px, -${track.h / 2}px)` }} />;
    // const departureAirport = <img className="airport-icon" src={markerDeparture} alt="airport icon" />;
    // const arivalAirport = <img className="airport-icon" src={markerArival} alt="airport icon" />;
    const track = frames ? frames[index] : {};
    const departureAirport = getAirport(flightSegment?.origin?.code);
    const arivalAirport = getAirport(flightSegment?.destination?.code);
    const markers: IExtLocation[] = [
        {
            lat: flightPosition?.latitude ?? 0,
            lng: flightPosition?.longitude ?? 0,
            divIcon: {
                className: "leaflet-marker-icon",
                iconSize: [track.w, track.h],
                html: `<div class="flight-marker-icon" style="width: ${track.w}px; height: ${track.h}px; background-position: -${track.x}px -${track.y}px;" />`
            }
        },
        {
            lat: departureAirport.latitude ?? 0,
            lng: departureAirport.longitude ?? 0,
            icon: {
                iconUrl: markerDeparture,
                iconAnchor: [17, 34]
            }
        },
        {
            lat: arivalAirport.latitude ?? 0,
            lng: arivalAirport.longitude ?? 0,
            icon: {
                iconUrl: markerArival,
                iconAnchor: [17, 34]
            }
        },
    ]
    const polyline: IPolyline = {
        paths: [path],
        polyLineOption: { color: '#00a693' }
    };

    return (
        <div className="trip-track-map-tracking">
            <Map
                height="100%"
                markers={trip?.id ? markers : setMarkerByTripData(trip)}
                onesFitBound={trip?.id ? true : false}
                fitBound
                polyline={trip?.id ? polyline : { paths: setPolyLineByTripData(trip), polyLineOption: { color: '#00a693' } }}
                markerIcon={marker}
                mode={MapType.Leaflet}
                leafletLayerName={LeafletLayerName.StandardLayer}
                leafletMapOption={{
                    initial: {
                        center: { lat: flightPosition?.latitude ?? 0, lng: flightPosition?.longitude ?? 0 },
                        dragging: trip?.id ? true : false,
                        scrollWheelZoom: trip?.id ? true : false,
                    },
                    current: {
                        center: { lat: flightPosition?.latitude ?? 0, lng: flightPosition?.longitude ?? 0 },
                        dragging: trip?.id ? true : false,
                        scrollWheelZoom: trip?.id ? true : false,
                    }
                }}
                leafletFitBoundOption={{
                    padding: [15, 0]
                }}
            // fitBound
            />
            {(!trip?.id) && <div className="popup">
                <section className='track_not_found'>
                    {trip ? tr('trip_track_not_found') : tr('msg_info_loading')}
                </section>
            </div>}
        </div>
    )
}

const setMarkerByTripData = (trip?: ITripTrackingTrip): IExtLocation[] => {
    const defaultMarker: IExtLocation = { lat: 35.686830586, lng: 51.308165434, icon: setIconForMarkers(markerDeparture), remainedState: false };
    const originMarker: IExtLocation = trip ? { lat: getAirport(trip?.flightSegment?.origin?.code).latitude!, lng: getAirport(trip?.flightSegment?.origin?.code).longitude!, icon: setIconForMarkers(markerDeparture) } : defaultMarker;
    const destinationMarker: IExtLocation = trip ? { lat: getAirport(trip?.flightSegment?.destination?.code).latitude!, lng: getAirport(trip?.flightSegment?.destination?.code).longitude!, icon: setIconForMarkers(markerArival) } : defaultMarker;
    return [originMarker, destinationMarker]
}

const setPolyLineByTripData = (trip?: ITripTrackingTrip): ILocation[][] => {
    const defaultMarker = { lat: 35.686830586, lng: 51.308165434 };
    const originMarker: ILocation = trip ? { lat: getAirport(trip?.flightSegment?.origin?.code).latitude!, lng: getAirport(trip?.flightSegment?.origin?.code).longitude! } : defaultMarker;
    const destinationMarker: ILocation = trip ? { lat: getAirport(trip?.flightSegment?.destination?.code).latitude!, lng: getAirport(trip?.flightSegment?.destination?.code).longitude! } : defaultMarker;
    return [[originMarker, destinationMarker]]
}

export default TripTrackMapTracking;